export default __webpack_public_path__ + "static/media/ady_jakubovitz.b770b53a.jpeg";